/**
 * Texts for User Training page - Swedish
 */
export const userTrainingPageText = {
    title: 'Användarutbildning - CamAPS FX',
    titleMeta: 'Omfattande utbildningsresurser för CamAPS FX-användare',
    descriptionMeta: 'Tillgång till kompletta utbildningsmaterial, videohandledningar, användarguider och webbinarier för att få ut det mesta av CamAPS FX.',
    keywords:
        'camaps fx användarutbildning, camaps utbildning, diabetesutbildning, insulinpump utbildning, användarguide, videohandledningar',
    localeMeta: 'sv_se',

    mainHeader: 'Användarutbildning',
    mainSubHeader: 'Slutför den grundläggande utbildningen i appen innan du använder CamAPS FX-appen.',

    gettingStartedHeader: 'Komma igång',
    step1Title: '<strong>Steg 1:</strong><br/>Ladda ner appen',
    step2Title: '<strong>Steg 2:</strong><br/>Skapa ett konto',
    step3Title: '<strong>Steg 3:</strong><br/>Påbörja den grundläggande utbildningen i appen',
    step4Title: '<strong>Steg 4:</strong><br/>Para ihop med din valda pump och CGM (med godkännande från ditt vårdteam) eller utforska appen med <strong>virtuellt läge</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Behöver du hjälp med att installera appen?',
    supportSectionText: 'Besök vår supportsektion för vägledning',
    supportButtonText: 'STÖD',
    findOutMoreButtonText: 'LÄS MER',

    additionalResourcesTitle: 'Ytterligare resurser',
    additionalResourcesSubtitle: 'Lär dig genom steg-för-steg-bilder eller titta på expertledda sessioner om hur man använder appen.',
    
    animationsTitle: 'Animationer',
    animationsDescription: 'Korta animationer för att hjälpa till att svara på några av CamDiabs vanligaste frågoDana insulinpumpen är för närvarande endast kommersiellt tillgänglig med CamAPS FX i Storbritannien. Alla resurser relaterade till Dana är därför endast tillgängliga på engelska.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webbinarier',
    webinarsDescription: 'Dessa webbseminarier är lämpliga för personer som lever med typ 1-diabetes, deras familj och vårdare samt lärare, utbildningsstödpersonal och vårdpersonal.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Faktablad',
    factsheetsDescription: 'Dana insulinpumpen är för närvarande endast kommersiellt tillgänglig med CamAPS FX i Storbritannien. Alla resurser relaterade till Dana är därför endast tillgängliga på engelska.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Utbildning i appen',
    inAppTrainingText: 'Börja med den grundläggande utbildningen som är inbyggd i CamAPS FX-appen. Denna interaktiva utbildning guidar dig genom alla viktiga funktioner du behöver känna till.<br/><br/><strong>Åtkomst:</strong> Ladda ner CamAPS FX-appen och skapa ett konto för att påbörja din utbildning i appen.',

    gettingStartedText: '<strong>Steg 1:</strong> Ladda ner CamAPS FX-appen från din enhets appbutik<br/><strong>Steg 2:</strong> Skapa ditt konto<br/><strong>Steg 3:</strong> Slutför utbildningsmodulerna i appen<br/><strong>Steg 4:</strong> Anslut din insulinpump och CGM<br/><strong>Steg 5:</strong> Påbörja din CamAPS FX-resa',

    trainingResourcesHeader: 'Ytterligare utbildningsresurser',
    videoTutorialsText: 'Videohandledningar',
    videoTutorialsDesc: 'Titta på steg-för-steg-videoguider som täcker installation, daglig användning och felsökning.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Användarguider och dokumentation',
    userGuidesDesc: 'Ladda ner omfattande PDF-guider och snabbreferensmaterial.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live-webbinarier',
    webinarsDesc: 'Delta i expertledda utbildningar och frågor och svar-tillfällen.',

    needHelpHeader: 'Behöver du hjälp?',
    needHelpTextStart: 'Om du behöver hjälp eller har frågor, besök vår',
    supportLinkText: 'Support',
    needHelpTextEnd: 'sida för ytterligare hjälp och kontaktinformation.'
};

